var n=function(n,r){return null==n?void 0:n[r]};export{n as _};
